// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"6d6f4264","900":"683b8081"}[chunkId] + ".chunk.js";
};